/* eslint-disable max-len */
// Dependencies
import React, {useState} from 'react'
import {connect} from 'react-redux'

// import Helpers from '../Helpers.js'
import {storePayload} from '../actions/storePayload'

// Images

// Styles
import '@lazarusai/forms-ui-components/dist/index.css'
import stylesLogTable from '../styles/LogTable.module.css'
import {Icon} from '@lazarusai/forms-ui-components'
import Helpers from '../Helpers'

// Components

function LogTable({
  sortingKey = 'timestamp',
  onClick = () => {},
  ...props
}) {
  const [descendingSort, setDescendingSort] = useState(true)

  function toggleSort() {
    setDescendingSort(!descendingSort)
  }

  return (
    <div
      className={stylesLogTable['log-table']}
    >
      <div
        className={stylesLogTable['log-table-header']}
      >
        {props.title || 'Log List'}
        <Icon
          key={descendingSort ? 'desc-icon': 'inc-icon'}
          icon={descendingSort ? 'arrow-ios-downward-outline': 'arrow-ios-upward-outline'}
          className={stylesLogTable['log-table-filter']}
          onClick={toggleSort}
        />
      </div>
      <div
        className={stylesLogTable['log-table-body']}
      >
        {(props.logs || []).sort((aLog, bLog) => {
          const aVal = aLog?.[sortingKey] || 0
          const bVal = bLog?.[sortingKey] || 0
          return (descendingSort) ? bVal - aVal : aVal - bVal
        }).map((log, lIndex) => {
          const logAction = log?.action || 'Action'
          const logTimestamp = log?.timestamp || 0
          return (
            <div
              className={`${props.singleVal ? stylesLogTable['log-table-row-single'] : ''} ${stylesLogTable['log-table-row']}`}
              key={`${lIndex}-log-row`}
              onClick={() => {
                if (log?.id) {
                  onClick(log?.id)
                } else {
                  onClick(lIndex)
                }
              }}
              style={props.selectedId === log.id ? {
                background: '#4D4D4D',
              } : {}}
            >
              {!props.singleVal &&
                <span>{logAction}</span>
              }
              <span>{`${Helpers.timeStampToDate(logTimestamp)} ${Helpers.timeStampToTime(logTimestamp)}`}</span>
            </div>
          )
        })}
      </div>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => ({
  theme: state.userReducer.theme,
  cookies: ownProps.cookies,
  storage: state.firebaseReducer.storage,
  database: state.firebaseReducer.database,
  firestore: state.firebaseReducer.firestore,
  userMessage: state.userReducer.userMessage,
  notificationType: state.userReducer.notificationType,
  notificationIcon: state.userReducer.notificationIcon,
  lang: state.userReducer.lang,
  isSignedIn: state.userReducer.isSignedIn,
  isFirebaseSignedIn: state.userReducer.isFirebaseSignedIn,
  isMFANeeded: state.userReducer.isMFANeeded,
  mfaError: state.userReducer.mfaError,
  user: state.userReducer.user,
  currentTasks: state.userReducer.currentTasks,
  taskId: state.userReducer.taskId,
})

export default connect(
    mapStateToProps,
    {storePayload},
)(LogTable)
